import { render } from "./CookieStartButton.vue?vue&type=template&id=5d500106&scoped=true"
import script from "./CookieStartButton.vue?vue&type=script&lang=js"
export * from "./CookieStartButton.vue?vue&type=script&lang=js"

import "./CookieStartButton.vue?vue&type=style&index=0&id=5d500106&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d500106"]])

export default __exports__